







































import _ from 'lodash';
import {Component, Mixins} from "vue-property-decorator";
import NumberGenerator from "@/common/mixins/numberGenerator";
import AllYouCanEatDrink from "@/common/mixins/allYouCanDrinkEat";
import { ReloadManager } from "@/common/util/reloadManager";
import QDetailModal from "@/components/qDetailModal.vue";
import Menu from "@/model/menu";
import OrderComponent from "@/components/order/orderComponent.vue";
import {namespace} from "vuex-class";
import System from "@/model/system";

const menuStore = namespace("MenuStore");
const systemStore = namespace("SystemStore");
const languageStore = namespace("LanguageStore")

@Component({
  name: "RecommendationList",
  components: {OrderComponent, QDetailModal},
})
export default class RecommendationList extends Mixins(NumberGenerator, AllYouCanEatDrink) {
  @menuStore.Getter
  getRawMenuList!: Menu[];
  @systemStore.Getter
  getSystem!: System;
  @languageStore.Getter
  getMenuNameKey: string

  async mounted() {
    ReloadManager.load(this.getSystem).connectSocket();
  }

  private get namekey() {
    return this.getMenuNameKey;
  }

  get menuRecommendedList(): Menu[] {
    const items = _.filter(
      this.getRawMenuList,
      item => (item.ranking !== "" && Number.parseInt(item.ranking) > 0)
    );

    return _.sortBy(items, item => Number.parseInt(item.ranking));
  }

  public openMenuDetail(menu, isEdit = false) {
    this.detailModal(menu, isEdit);
  }

  public detailModal(menu, isEdit) {
    (this.$refs.qDetailModal as QDetailModal).show(menu, isEdit);
  }
}
